import axios, { AxiosInstance } from "axios";
import { baseUrl_V2 } from "src/utils/config";
import { getToken, renewSessionOn401 } from "src/utils/session";

const axiosInstance: AxiosInstance = axios.create({
  baseURL: baseUrl_V2,
  // TODO this needs to be changed
  timeout: 10000000,
  headers: {
    contentType: "application/json",
    accept: "application/json",
  },
});

export const getSessionId = () => {
  try {
    let sessionId = localStorage.getItem("analytics");
    if (sessionId) {
      sessionId = JSON.parse(sessionId);
      return sessionId["x-session-id"];
    }
    return "";
  } catch (error) {
    return "";
  }
};

axiosInstance.interceptors.request.use(
  (config) => {
    if (!config.headers.token) {
      const token = getToken();
      if (token) {
        config.headers.Authorization = `Bearer ${token}`;
      }
    }
    if (!config.headers["x-session-id"])
      config.headers["x-session-id"] = getSessionId();

    if (config.baseURL === "v2")
      config.baseURL = baseUrl_V2;
    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);

/* A refused token is renewed once and the request sent again; when it cannot
   be renewed, the client goes to sign in. See utils/session. */
renewSessionOn401(axiosInstance);

export { axiosInstance };
export default axiosInstance;
